import { useContext, useState, useEffect } from "react";
import { ChannelsContext } from "../../../context/ChannelsContext";
import { ChannelSideBarContext } from "../../../context/Channels/ChannelSideBarContext";
import {
  disableOrEnableButtonsSave,
  disableButtonSave,
} from "../Emissora/EmissoraUtil";
import { ImageWithFallback } from "../Image/ImageWithFallback";

export const defaultColumnColors = [
  { color: "#b40931", colorId: 0 },
  { color: "#cc5d09", colorId: 1 },
  { color: "#cca109", colorId: 2 },
  { color: "#8ccd01", colorId: 3 },
  { color: "#49b153", colorId: 4 },
  { color: "#27c1b8", colorId: 5 },
  { color: "#0b89ca", colorId: 6 },
  { color: "#213ba8", colorId: 7 },
  { color: "#941ec5", colorId: 8 },
  { color: "#b8b8b8", colorId: 9 },
];

function EmissoraColor() {
  const [colorClicked, setColorClicked] = useState();
  const [colorShow, setColorShow] = useState(false);
  const { channelsMenuTemp, changeColor } =
    useContext(ChannelsContext);

  const {
    setChannelButtonEdit,
    channelColorSaved,
    setChannelColorSaved,
    setButtonChannel,
  } = useContext(ChannelSideBarContext);

  useEffect(() => {
    handleLoad();
  }, []);

  useEffect(() => {
    handleLoad();
  }, [channelsMenuTemp]);

  function handleLoad() {
    disableButtonSave(
      "buttonChannelColor",
      "buttonChannelCancelColor",
      channelColorSaved,
      setChannelColorSaved,
      setButtonChannel,
      document
    );
  }

  const colorIcon = (item) => (
    <div
      id="colorIcon"
      data-testid="colorIcon"
      style={{
        width: 30,
        height: 30,
        backgroundColor: item.color,
        border: "1px solid #999",
        float: "left",
        marginRight: 10,
        cursor: "pointer",
      }}
      onClick={() => {
        if (item.id !== colorClicked) {
          setColorShow(true);
        } else if (item.id === colorClicked) {
          setColorShow(!colorShow);
        }
        setColorClicked(item.id);
      }}
    ></div>
  );

  const colorsChoose = (color, key) => (
    <div
      id="colorsChoose"
      data-testid="colorsChoose"
      style={{
        width: 30,
        height: 30,
        backgroundColor: color,
        border: "1px solid #999",
        float: "left",
        marginRight: 10,
        cursor: "pointer",
      }}
      onClick={() => {
        channelChangeColor(color, key);
      }}
    ></div>
  );

  const colorLine = (key) => {
    return defaultColumnColors.map((color, i) => (
      <a
        id={"colorLine" + i}
        className="channelsColor"
        key={"color_" + color.colorId}
      >
        {colorsChoose(color.color, key)}
      </a>
    ));
  };

  function channelChangeColor(color, idkey) {
    changeColor(color, idkey);
    setButtonChannel(true);
    setChannelButtonEdit(true);
    setColorShow(false);
    disableOrEnableButtonsSave(
      "buttonChannelColor",
      "buttonChannelCancelColor",
      false,
      document
    );
  }
  return (
    <div data-testid="divEmissoraColor">
      <ul className="nav-menu-items-praca" style={{ marginBottom: "2px" }}>
        {channelsMenuTemp?.enabled?.map((item, index) => {
          return (
            <div key={item.id} style={{ display: "grid" }}>
              <li key={item.id} className="nav-text">
                {colorIcon(item)}
                <ImageWithFallback
                  key={item.id}
                  title={item.label}
                  src={item.icons.menuBitmap}
                  style={{
                    width: "30px",
                    marginRight: "10px",
                    marginLeft: "5px",
                  }}
                  dataid={item.id}
                  className="nav-text-praca"
                  showTitle={true}
                />
              </li>
              {colorShow ? (
                <div
                  className={colorClicked === item.id ? "" : "nav-menu-hidden"}
                >
                  <ul className="ulColor">
                    <li className="liColor">{colorLine(item.id)}</li>
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          );
        })}
      </ul>
    </div>
  );
}
export default EmissoraColor;
